export type KeyFn = {
  // eslint-disable-next-line id-blacklist
  (item: any, index: number): string
}

export type SearchFn = {
  // eslint-disable-next-line id-blacklist
  (item: any, index: number, searchText: string): boolean
}

export type ListItem = {
  value: any
}

export enum ListDirection {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}

export type AColGrid = Partial<Record<'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs', number>> | Record<'span', number>

export type ListConfig = {
  data: Array<ListItem>
  keyFn: KeyFn
  direction?: ListDirection
  searchFn?: SearchFn
  paginateBy?: number
  listItemClasses?: Array<string> | Record<string, any>
  grid?: AColGrid
}
